import { OPEN_EDITION_MAX_MINTABLE } from '@soundxyz/utils/constants/constants';
import type { MintingTypes } from '@soundxyz/utils/constants/enums';

export const isOpenEdition = (quantity: number): boolean => quantity >= OPEN_EDITION_MAX_MINTABLE;

export const dropdownValueKey = ({ type, id }: { type: MintingTypes; id: string }) =>
  `${type}-${id}`;
